export default __webpack_public_path__ + "static/media/quote-block-thumbnail-light.b5788c13.svg";